import React from 'react';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { LINE_QRCODE_PRODUCT_BARS } from 'Utils/request/requestDictionary';
import { useGQLErrorsHandler } from 'Utils/use-gql-errors-handler/useGQLErrorsHandler';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { FacilitiesHours } from 'Components/widgets/facilities-hours/FacilitiesHours';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { asGqlData } from 'Src/types/cast-helpers';
import { getProductBarsQuery } from './QRCodeProductBarsLine.utils';
type Props = {
  bookATable: string;
  openingHours: string;
  resortId: string;
  title: string;
};
export const QRCodeProductBarsLine = ({ resortId, title, ...rest }: Props) => {
  // Implementation carried on the component side to correct the problem of the timezone of the resort
  const { isLoading, data, error } = useGQL({
    query: getProductBarsQuery(resortId),
    queryOptions: {
      requestName: LINE_QRCODE_PRODUCT_BARS,
      cacheFront: {
        key: LINE_QRCODE_PRODUCT_BARS + resortId,
      },
    },
    cache: false,
    ignore: !resortId,
  });
  useGQLErrorsHandler(error, {
    catchAuthError: true,
  });
  const track = useTracking({
    actionGA: 'Bar & Restaurant',
    categoryGA: 'landing',
  });

  if (!resortId) {
    return null;
  }

  const gqlData = asGqlData<{ resort?: { facilities?: Array<ProductFacility> } }>(data);
  const facilities: Array<ProductFacility> = gqlData?.resort?.facilities || [];
  return (
    <SiteContainer className="Line" data-testid="qrcode-product-bars" size="small">
      <LineTitle>{title}</LineTitle>
      {isLoading ? (
        <div className="flex items-center justify-center">
          <Spinner size="small" />
        </div>
      ) : (
        <FacilitiesHours
          {...rest}
          facilities={facilities}
          onFacilityClick={() =>
            track({
              labelGA: 'book a table',
            })
          }
          onTabClick={() =>
            track({
              labelGA: 'tabs',
            })
          }
        />
      )}
    </SiteContainer>
  );
};
